import React from 'react';
import { useFela } from 'react-fela';
import { applySpaceMultiplier } from '../../utils/apply-space-multiplier';
import { responsiveNumberOrStringProp } from '../../utils/prop-types-utils';
import { View } from '../view';

/**
 * @deprecated Use margin or gaps instead. Read [Layout](https://developer.volvocars.com/design-system/web/?path=/docs/layout-introduction--docs)
 */
export function Spacer(_ref) {
  let {
    size = 1
  } = _ref;
  const {
    theme
  } = useFela();
  const spacing = applySpaceMultiplier(theme.baselineGrid);
  return /*#__PURE__*/React.createElement(View, {
    width: spacing(size),
    basis: spacing(size)
  });
}
Spacer.propTypes = {
  size: responsiveNumberOrStringProp
};